import React from "react";


// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
import MDAvatar from "components/MDAvatar";

// core components
import { useState } from 'react';
import { useQuery } from "react-query";
import BackupIcon from '@mui/icons-material/SettingsBackupRestore';

import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from "axios";
import { Alert } from '@mui/material';
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";



export default function RawBackupDetailTable(props) {
  const url = "/api/v1/rawbackup";
  const [token, setToken] = useToken();
  useAxiosAuth(token);

  const BackupName = () => (
      <BackupIcon fontSize="medium" />
  );

  const columns = [
    { Header: "", accessor: "icon", width: "1px"},
    { Header: "Name", accessor: "name", width: "35%", align: "left" },
    { Header: "Last Modified", accessor: "lastModified", align: "left", isSorted: true, isSortedDesc: "desc" },
    { Header: "Size (GB)", accessor: "size", align: "center" }
  ];
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [restoredFile, setRestoredFile] = useState("");
  const [isError, setIsError] = useState(false);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [anchorElPop, setAnchorElPop] = React.useState(null);
  const openRestorePop = Boolean(anchorElPop);
  const restorePopId = openRestorePop ? 'restore-popover' : undefined;

  const { isLoading, error, data } = useQuery(
    "backupdetail", () => axios.get(
      url + "/" + props.rawBackupId,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => res.data
    ),
    {
      refetchInterval: 30000
    }
  )

  const backupData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };

    if (data) {
      if (data.length > 0) {
        tableData.rows = data.map((item) => {
            return {
              icon: <BackupName />,
              name: (item.name) ? item.name : "",
              lastModified: (item.lastModified) ? item.lastModified : "",
              size: (item.size) ? (item.size/(1024*1024*1024)).toPrecision(6) : ""
            }
          }
        )
      }
    }

    return tableData;
  }

  const openRestorePopover = (event) => {
    setAnchorElPop(event.currentTarget);
  }

  const closeRestorePop = (event) => {
    setAnchorElPop(null);
  }

  return (
    <React.Fragment>
        {isError ?
          <Box sx={{ paddingLeft: "10px" }}>
            <Alert severity="error">
              {message ? message : "error"}
            </Alert>
          </Box>
          : null
        }
        {error ?
          <Box>
            <Alert severity="error">
              Error loading backup data
            </Alert>
          </Box>
          : null
        }

      {isLoading && <CircularProgress size={24} style={{marginLeft: 15, position: 'relative', top: 4}} />}

      <DataTable
        tableTitle={"Raw Backup " + props.rawBackupId +  " Detail"}
        table={ backupData(data) }
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        initialSortField="lastModified"
        initialSortDesc={true}
        noEndBorder
        entriesPerPage={true}
      />
    </React.Fragment>
  );
}
